export const AUTH_CONFIG = {
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
  domain: 'auth.swiftaid.co.uk',
  audience: import.meta.env.VITE_SWIFTAID_API_URL,
  scope: 'openid profile',
}
